import { t } from '@lingui/core/macro';

import { SeoSlugEnum } from '@rover/constants/src/search/seo.constants';

export const DATE_PICKER_START_PLACEHOLDER_FOR_SEO_SLUG = (): Record<
  Exclude<
    SeoSlugEnum,
    SeoSlugEnum.DOG_TRAINING | SeoSlugEnum.DOG_SITTING | SeoSlugEnum.PET_BOARDING
  >,
  string
> => ({
  [SeoSlugEnum.DOG_BOARDING]: t`Drop off`,
  [SeoSlugEnum.DOG_WALKING]: t`Start`,
  [SeoSlugEnum.DOGGY_DAY_CARE]: t`Start`,
  [SeoSlugEnum.HOUSE_SITTING]: t`Start`,
  [SeoSlugEnum.CAT_SITTING]: t`Start`,
  [SeoSlugEnum.PET_SITTING]: t`Start`,
});

export const DATE_PICKER_END_PLACEHOLDER_FOR_SEO_SLUG = (): Record<
  Exclude<
    SeoSlugEnum,
    SeoSlugEnum.DOG_TRAINING | SeoSlugEnum.DOG_SITTING | SeoSlugEnum.PET_BOARDING
  >,
  string
> => ({
  [SeoSlugEnum.DOG_BOARDING]: t`Pick up`,
  [SeoSlugEnum.DOG_WALKING]: t`End`,
  [SeoSlugEnum.DOGGY_DAY_CARE]: t`End`,
  [SeoSlugEnum.HOUSE_SITTING]: t`End`,
  [SeoSlugEnum.CAT_SITTING]: t`End`,
  [SeoSlugEnum.PET_SITTING]: t`End`,
});
